import { useAppDispatch } from './useAppDispatcher.hook';
import { EnglishLevel } from '../redux/Candidate/English/EnglishLevel.type';
import { getEnglishLevelListThunk } from '../redux/Candidate/English/EnglishLevel.thunk';

const useEnglishLevel = () => {
  const dispatch = useAppDispatch();

  return {
    getSelectList: async (search: string, loadedOptions: string | any[]) => {
      const {
        payload: { data },
      } = await dispatch(getEnglishLevelListThunk({}));
      return {
        options: data.map((item: EnglishLevel) => ({
          value: item.id,
          label: item.level,
        })),
        hasMore: false,
      };
    },
    getSelectListByIds: async (ids: Array<number>) => {
      const {
        payload: { data },
      } = await dispatch(getEnglishLevelListThunk({ ids }));
      return data.map((item: EnglishLevel) => ({
        value: item.id,
        label: item.level,
      }));
    },
  };
};

export default useEnglishLevel;
